import {PRODUCTION, STAGING} from './environments';

export interface Flags {
  BLOG_SEARCH: boolean;
  CONFIGURABLE_LANGUAGE: boolean;
  CROSS_BUSINESS_SERVICES: boolean;
  DASHBOARD_ALL_APPLICATIONS: boolean;
  DISPLAY_AISP: boolean;
  DOCUMENT_UPLOAD: boolean;
  GREEN_FINANCE: boolean;
  ING_REFERRAL: boolean;
  KNOWLEDGE_HUB_SEARCH: boolean;
  MAILCHIMP_FORM: boolean;
  OPEN_ACCOUNTING: boolean;
  PARTNERS_PAGES: boolean;
  PARTNERS_PAGES_NL: boolean;
  PARTNERS_USE_FORM: boolean;
  PRESS_PAGE: boolean;
  QUOTE_FORM_ACCOUNT: boolean;
  QUOTE_FORM_PROPERTY_IS_KNOWN_ADDRESS: boolean;
  SEND_VERIFY_EMAIL: boolean;
  SHOW_NUMBER_MATCHES: boolean;
  SHOW_RATES: boolean;
  URL_QUOTE_FORM: boolean;
  DOCUMENT_UPLOAD_NAVIGATE_TO_DASHBOARD: boolean;
}

const flags: Flags = {
  BLOG_SEARCH: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  CONFIGURABLE_LANGUAGE: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  CROSS_BUSINESS_SERVICES: process.env.STAGE !== PRODUCTION,
  DASHBOARD_ALL_APPLICATIONS: process.env.STAGE !== PRODUCTION,
  DISPLAY_AISP: process.env.STAGE !== PRODUCTION,
  DOCUMENT_UPLOAD: process.env.STAGE !== PRODUCTION,
  DOCUMENT_UPLOAD_NAVIGATE_TO_DASHBOARD: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  GREEN_FINANCE: process.env.STAGE !== PRODUCTION,
  ING_REFERRAL: true,
  KNOWLEDGE_HUB_SEARCH: false,
  MAILCHIMP_FORM: true,
  OPEN_ACCOUNTING: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  PARTNERS_PAGES: true,
  PARTNERS_PAGES_NL: process.env.STAGE !== PRODUCTION,
  PARTNERS_USE_FORM: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  PRESS_PAGE: process.env.STAGE !== PRODUCTION,
  QUOTE_FORM_ACCOUNT: true,
  QUOTE_FORM_PROPERTY_IS_KNOWN_ADDRESS: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  SEND_VERIFY_EMAIL: false,
  SHOW_NUMBER_MATCHES: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  SHOW_RATES: true,
  URL_QUOTE_FORM: process.env.STAGE !== PRODUCTION,
};

export default flags;
